import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
const HowToSearch = _ref => {
  let {
    showInstruction
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "top",
    overlay: /*#__PURE__*/React.createElement(Tooltip, null, t('how_to_search'))
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#0078B9',
      cursor: 'pointer'
    },
    onClick: () => showInstruction(true),
    className: "material-icons"
  }, "help"));
};
export default HowToSearch;